import styled from "styled-components"

import WidgetHeader from "./WidgetHeader"

const Container = styled.div`
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 0 32px 20px;
  flex: 1 0 420px;
  min-height: 173px;
  position: relative;

  @media only screen and (max-width: 900px) {
    flex: 1 0 60%;
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

interface WidgetsLayoutProps {
  title: string
  children: React.ReactNode
  includeCustomRangeSelect?: boolean
  onSelectDateRange: (date: [string, string]) => void
}

const WidgetsLayout = ({ children, title, includeCustomRangeSelect, onSelectDateRange }: WidgetsLayoutProps) => {
  return (
    <Container>
      <WidgetHeader
        title={title}
        includeCustomRangeSelect={includeCustomRangeSelect}
        onSelectDateRange={onSelectDateRange}
      />
      {children}
    </Container>
  )
}

export default WidgetsLayout
